import { PUBLIC_API_ENDPOINT } from "../constants"

export const getTranslations = async () => {
	const headers = {
		Accept: "application/json",
	}

	const options: RequestInit = {
		headers: headers,
		mode: "cors",
		credentials: "include",
	}

	return fetch(`${PUBLIC_API_ENDPOINT}/settings/translations`, options).then(
		(r) => {
			return r.json()
		}
	)
}
